import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { EmployeeCropTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { MonthlyCollectionSchemaObject } from '../MonthlyCollectionSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "EMPLOYEECROPREPORT";

export function MonthlyCollectionListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [monthlyCollectionDetails, setMonthlyCollectionDetails] = useState({
        groupID: "0",
        estateID: "0",
        fromDate: "",
        toDate: "",
        regNumber: "",
        employeeType: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        fromDate: "",
        toDate: "",
        regNumber: "",
        employeeType: "0"
    });

    const csvHeaders = [
        { label: "Type", value: "type" },
        { label: "Date", value: "date" },
        { label: "No Of Bags", value: "noOfBags" },
        { label: "Net Amount", value: "netAmount" },
        { label: "Extra Kg", value: "extraKg" },
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [detailCard, setDetailCard] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(MonthlyCollectionSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["date", "noOfBags", "netAmount", "extraKg"];

    const [rsmReportData, setRsmReportData] = useState([]);
    const [generalReportData, setGeneralRReportData] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [isRecordsAvailable, setIsRecordsAvailable] = useState(false);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [monthlyCollectionDetails.groupID])


    useEffect(() => {
        setIsTableHide(true);
    }, [monthlyCollectionDetails.employeeType]);

    useEffect(() => {
        addWeighDetailsToCsv();
    }, [detailCard]);

    function handleGroupChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: target.value,
            estateID: "0",

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            estateID: target.value,
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            fromDate: target.value
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            toDate: target.value
        });
    }

    function handleregNumber(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            regNumber: target.value
        });
    }

    function handleEmployeeTypeChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            employeeType: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, MonthlyCollectionSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEECROPREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(monthlyCollectionDetails.groupID);
        setEstates(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, monthlyCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getEmployeeCropReportData(monthlyCollectionDetails);
        setEmployeeData(result.employeeData);

        var reportData = result.employeeCropReportsData;

        var piviotResult = pivotReportData(reportData);
        var dataAddedByDate = addByDate(piviotResult);

        var rsmData = [];
        var generalData = [];

        dataAddedByDate.forEach(x => {
            x.date = x.date.split('T')[0];
            x.netAmount = x.netAmount.toFixed(2);
            x.extraKg = x.extraKg.toFixed(2);
            if (x.accountTypeID === 1) {
                generalData.push(x);
            } else {
                rsmData.push(x);
            }
        });

        getSelectedDropdownValuesForReport(monthlyCollectionDetails);

        if (monthlyCollectionDetails.employeeType === "0") {
            setRsmReportData(rsmData);
            setGeneralRReportData(generalData);
            setCsvData([...rsmData, ...generalData]);
            calculateCardDetails(dataAddedByDate, result);

            if (rsmData.length > 0 || generalData.length > 0)
                setIsRecordsAvailable(true);
            else
                setIsRecordsAvailable(false);

        } else if (monthlyCollectionDetails.employeeType === "1") {
            setGeneralRReportData(generalData);
            setCsvData(generalData);
            calculateCardDetails(generalData, result);

            if (generalData.length > 0)
                setIsRecordsAvailable(true);
            else
                setIsRecordsAvailable(false);

        } else {
            setRsmReportData(rsmData);
            setCsvData(rsmData);
            calculateCardDetails(rsmData, result);

            if (rsmData.length > 0)
                setIsRecordsAvailable(true);
            else
                setIsRecordsAvailable(false);

        }

        if (result.employeeCropReportsData.length != 0) {
            setIsTableHide(false);
            createDataTable();
        }
    }

    function addWeighDetailsToCsv() {
        var data = csvData;
        var details = [{},
        {
            type: "Total",
            date: "Weigh Details",
            noOfBags: detailCard.bagCount,
            netAmount: detailCard.net,
            extraKg: detailCard.extraKilo
        }
        ]
        data = [...data, ...details];
        setCsvData(data);
    }

    function pivotReportData(data) {
        var result = [];
        data.forEach(x => {
            if (result.length <= 0) {
                result.push(x);
            } else {
                var selectedRecord = result.find(y => y.pluckingCollectionID === x.pluckingCollectionID);
                if (selectedRecord === undefined) {
                    result.push(x);
                } else {
                    selectedRecord.extraKg += x.extraKg;
                    selectedRecord.netAmount += x.netAmount;
                }
            }
        });
        return result;
    }

    function addByDate(data) {
        var result = [];
        data.forEach(x => {
            if (result.length <= 0) {
                x.type = x.accountTypeID === 1 ? "General" : "Rsm";
                result.push(x);
            } else {
                var selectedRecord = result.find(y => y.date === x.date && y.accountTypeID === x.accountTypeID);
                if (selectedRecord === undefined) {
                    x.type = x.accountTypeID === 1 ? "General" : "Rsm";
                    result.push(x);
                } else {
                    selectedRecord.extraKg += x.extraKg;
                    selectedRecord.netAmount += x.netAmount;
                    selectedRecord.noOfBags += x.noOfBags;
                    selectedRecord.type = x.accountTypeID === 1 ? "General" : "Rsm"
                }
            }
        });
        return result;
    }

    function calculateCardDetails(data, employeeData) {
        var totalResult = {
            bagCount: 0,
            net: 0,
            extraKilo: 0,
            cardNumber: employeeData.cardNumber,
            employeeBiomericData: employeeData.convertedEmployeeBiometricData
        };

        data.forEach(x => {
            totalResult.bagCount += x.noOfBags;
            totalResult.net += parseFloat(x.netAmount);
            totalResult.extraKilo += parseFloat(x.extraKg);
        });

        totalResult.net = totalResult.net.toFixed(2);
        totalResult.extraKilo = totalResult.extraKilo.toFixed(2);

        setDetailCard(totalResult);
    }

   

    function createFile() {
        var settings = {
            sheetName: 'Employee Crop Report',
            fileName: 'EmployeeCropReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            type: "Group :" + groups[monthlyCollectionDetails.groupID],
            date: "Estate : " + estates[monthlyCollectionDetails.estateID],
            noOfBags: "RegNo :" + monthlyCollectionDetails.regNumber
        }

        var newRow2 = {
            type: "From Date : " + monthlyCollectionDetails.fromDate,
            date: "To Date : " + monthlyCollectionDetails.toDate,
            noOfBags:"Employee Type :" + monthlyCollectionDetails.employeeType

        }

        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)

    }

    function onCancelClick() {
        clearState();
    }
    

    function clearState() {

        setMonthlyCollectionDetails({
            fromDate: "",
            toDate: "",
            regNumber: "",
            employeeType: "0"
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
            regNumber: searchForm.regNumber,
            employeeType: (searchForm.employeeType === "0") ? "All" : (searchForm.employeeType === "1" ? "General" : "Rsm")
        })
    }

    function returnCardNumber(type) {
        var result = employeeData.find(x => x.accountTypeID === type);
        return result === undefined ? [] : result.cardNumber;
    }

    function createDataTable() {
        if (monthlyCollectionDetails.employeeType !== "0") {
            $('#example').DataTable({
                destroy: true
            });
        } else {
            $('#rsm').DataTable({
                destroy: true
            });
            $('#general').DataTable({
                destroy: true
            });
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Crop Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={monthlyCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={monthlyCollectionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">Registartion Number*</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="regNumber"
                                            name="regNumber"
                                            type="regNumber"
                                            onChange={(e) => handleregNumber(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["regNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNumber"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="employeeType">Employee Type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="employeeType"
                                            id="employeeType"
                                            name="employeeType"
                                            value={monthlyCollectionDetails.employeeType}
                                            onChange={(e) => handleEmployeeTypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--All--</MenuItem>
                                            <MenuItem value="1">General</MenuItem>
                                            <MenuItem value="2">RSM</MenuItem>
                                        </Select>
                                        {errors["employeeType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeType"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, monthlyCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="card" style={{ width: "10rem;" }}>
                                        <div className="card-header"><h6>Weigh Details</h6></div>
                                        <div className="card-body">
                                            {
                                                (employeeData[0].convertedEmployeeBiometricData !== null &&
                                                    isRecordsAvailable) ? <img src={employeeData[0].convertedEmployeeBiometricData} width="75" height="75" /> : null
                                            }
                                            <p className="d-inline pl-3 pr-3"><b>Bag Count : </b> {detailCard.bagCount}</p>
                                            <p className="d-inline pr-3"><b>Net Weight : </b>{detailCard.net} Kg</p>
                                            <p className="d-inline pr-3"><b>Extra Kilo : </b>{detailCard.extraKilo} Kg</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            {(monthlyCollectionDetails.employeeType === "1" || monthlyCollectionDetails.employeeType === "2") ?
                                                <div>
                                                    <div><b><u>{monthlyCollectionDetails.employeeType === "2" ? "Rsm Details : " + returnCardNumber(2) : "General Details : " + returnCardNumber(1)}</u></b></div>
                                                    <div className="table-responsive row-top-gap">
                                                        <table id="example" className="display dataTable no-footer">
                                                            <thead>
                                                                <tr>
                                                                    <th> Date </th>
                                                                    <th> <center>Bag Count </center> </th>
                                                                    <th> <center>Net Weight (Kg) </center></th>
                                                                    <th> <center>Extra Kilo (Kg)</center></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <EmployeeCropTableContent
                                                                    data={monthlyCollectionDetails.employeeType === "2" ? rsmReportData : generalReportData}
                                                                    contentRowNames={contentRowNames}
                                                                    hasEdit={false}
                                                                />
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                : null
                                            }
                                            {monthlyCollectionDetails.employeeType === "0" ?
                                                <div>
                                                    <div className="card p-2">
                                                        <div className="pt-3 pb-3"><b><u>General Details :  {returnCardNumber(1)}</u></b></div>
                                                        <div className="table-responsive row-top-gap">
                                                            <table id="general" className="display dataTable no-footer">
                                                                <thead>
                                                                    <tr>
                                                                        <th> Date </th>
                                                                        <th> <center>Bag Count </center> </th>
                                                                        <th> <center>Net Weight (Kg) </center></th>
                                                                        <th> <center>Extra Kilo (Kg)</center></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <EmployeeCropTableContent
                                                                        data={generalReportData}
                                                                        contentRowNames={contentRowNames}
                                                                        hasEdit={false}
                                                                    />
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="card p-2">
                                                        <div className="pt-3 pb-3"><b><u>Rsm Details :  {returnCardNumber(2)}</u></b></div>
                                                        <div className="table-responsive row-top-gap">
                                                            <table id="rsm" className="display dataTable no-footer">
                                                                <thead>
                                                                    <tr>
                                                                        <th> Date </th>
                                                                        <th> <center>Bag Count </center> </th>
                                                                        <th> <center>Net Weight (Kg) </center></th>
                                                                        <th> <center>Extra Kilo (Kg)</center></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <EmployeeCropTableContent
                                                                        data={rsmReportData}
                                                                        contentRowNames={contentRowNames}
                                                                        hasEdit={false}
                                                                    />
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Employee Crop Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} monthlyCollectionDetails={monthlyCollectionDetails}
                                            rsmReportData={rsmReportData} generalReportData={generalReportData} employeeData={employeeData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} detailCard={detailCard} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
